import './LoginComponent.scss';
import Button from "react-bootstrap/Button";
import React, {useState} from "react";
import Form from "react-bootstrap/Form";

import {Modal} from "react-bootstrap";
import {toast} from "react-toastify";

const LoginComponent = ({onLogin = null}) => {
    const [modalResetPassword, setModalResetPassword] = useState(false);
    let login = (e) => {
        e.preventDefault();
        const email = e.target.elements.email.value;
        const password = e.target.elements.password.value;

        fetch(global.route.login, {
            method: "post", credentials: 'include',
            body: global.getFormData({
                email: email,
                password: password,
            })
        })
            .then(response => {
                if (response.status === 200) {
                    toast.success("Bentornato!")
                    response.json().then(response => {
                        if (onLogin !== null)
                            onLogin(response.user);
                    });
                } else {
                    global.catchError(response);
                }
            });
    }

    let resetPassword = (e) => {
        e.preventDefault();
        const email = e.target.elements.emailResetPassword.value;

        fetch(global.route.recoverPassword, {
            method: "post", credentials: 'include',
            body: global.getFormData({
                email: email,
            })
        })
            .then(response => {
                if (response.status === 200) {
                    toast.success("Controlla l'email per procedere con il recupero della password. Controlla nei messaggi della cartella spam. Se non ricevi la mail entro 24 ore scrivici a info@geoticket.it")
                    setModalResetPassword(false);
                } else {
                    global.catchError(response);
                }
            });
    }

    const getContent = () => {
        let content = [];
        content.push(
            <>
                <div className="d-flex justify-content-center">
                    <h3 className={"orange"}>Effettua il login</h3>
                </div>
                <br/>
                <Form onSubmit={login}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Inserisci email" required/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Inserisci password" required/>
                    </Form.Group>

                    <small><a href={"#"} onClick={() => setModalResetPassword(true)}>Password dimenticata?</a></small>
                    <div className="d-flex justify-content-center">
                        <Button variant="success" type="submit">
                            Entra
                        </Button>
                    </div>
                </Form>
            </>
        )
        return content;
    }


    return (
        <div className="login-container">
            {getContent()}
            <Modal show={modalResetPassword} centered onHide={() => setModalResetPassword(false)} style={{zIndex: 1057}}>
                <Modal.Header closeButton>
                    <h4>Reimposta password</h4>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={resetPassword}>
                        <Form.Group className="mb-3" controlId="emailResetPassword">
                            <Form.Label>Inserisci l'email per recuperare la password</Form.Label>
                            <Form.Control type="email" placeholder="Inserisci email"/>
                        </Form.Group>

                        <div className="d-flex justify-content-center">
                            <Button variant="success" type="submit">
                                Recupera password
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default LoginComponent;
